// extracted by mini-css-extract-plugin
export default {"BasicButtonContainer":"Button30_BasicButtonContainer__EjRdc","BasicButton":"Button30_BasicButton__DzPRu","DisabledButton":"Button30_DisabledButton__xyjnn"};